import trechoFactory from '@/factories/solicitacao/editando'
export default {
	data() {
		return {
			listaPaises: []
		}
	},
	methods: {
		// alternative_local foi adicionado para tratar casos de registros rotaer sem o id da cidade e com apenas a descrição, não foi realizado uma correção definitiva por conta dos dados do rotaer está sendo usado em vários locais do sistema.
		// Se caso você que está lendo essa mensagem já resolveu o problema ou irá resolver, remova esse comentário!
		requests(tipo, local, alternative_local) {
			return new Promise((resolve, reject) => {
				if (tipo === 'cidade') {
					let lista = this.rotaER.filter(
						(rotaER) =>
							rotaER.id_cidade == local ||
							rotaER.cidade ===
								this._removerAcentos(alternative_local).toUpperCase()
					)
					lista.push({sigla: 'ZZZZ', local: ''})
					resolve(lista)
				} else {
					const link = {
						pais: `/Estado/get_estado_pais?pais=${escape(local)}`,
						province: `Cidade/get_cidade_by_id_estado/${escape(local)}`
					}[tipo]
					this._httpGet(link, (response) => {
						resolve(response.lista)
					})
				}
			})
		},
		async carregaPaises() {
			return new Promise((resolve, reject) => {
				this._httpGet('Countries/getAll', (response) => {
					this.listaPaises = response.lista
					resolve(response.lista)
				})
			})
		},
		async carregarEditarTrecho(trecho) {
			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})
			const paises = await this.carregaPaises()
			return await Promise.all(
				trecho.map(async (dadosTrecho, indexTrecho) => {
					// QUANDO ADICIONAR UM CAMPO, LEMBRAR DE ADICONAR NO VISUALIAR
					let trechoPadrao = trechoFactory.createTrecho(true)

					const pais_partida =
						paises.find((pais) => pais.nome == dadosTrecho.pais_partida) ??
						trechoPadrao.pais_partida
					const pais_destino =
						paises.find((pais) => pais.nome == dadosTrecho.pais_destino) ??
						trechoPadrao.pais_destino
					trechoPadrao.lista_estados_partida = await this.requests(
						'pais',
						pais_partida?.nome ?? 'Brazil'
					)
					trechoPadrao.lista_estados_destino = await this.requests(
						'pais',
						pais_destino?.nome ?? 'Brazil'
					)
					const estado_partida = trechoPadrao.lista_estados_partida.find(
						(estado) => estado.id == dadosTrecho.id_estado_partida
					)
					const estado_destino = trechoPadrao.lista_estados_destino.find(
						(estado) => estado.id == dadosTrecho.id_estado_destino
					)
					trechoPadrao.lista_cidades_partida = await this.requests(
						'province',
						estado_partida.id
					)
					trechoPadrao.lista_cidades_destino = await this.requests(
						'province',
						estado_destino.id
					)
					const cidade_partida = trechoPadrao.lista_cidades_partida.find(
						(cidade) => cidade.id == dadosTrecho.id_cidade_partida
					)
					const cidade_destino = trechoPadrao.lista_cidades_destino.find(
						(cidade) => cidade.id == dadosTrecho.id_cidade_destino
					)
					trechoPadrao.rotaer_partida = await this.requests(
						'cidade',
						cidade_partida.id,
						cidade_partida.descricao
					)
					trechoPadrao.rotaer_destino = await this.requests(
						'cidade',
						cidade_destino.id,
						cidade_destino.descricao
					)
					let designativo_partida =
						trechoPadrao.rotaer_partida.find(
							(designativo) =>
								designativo.sigla == dadosTrecho.designativo_partida
						) ?? {}
					let designativo_destino = {}
					if (dadosTrecho.designativo_destino === 'ZZZZ') {
						designativo_destino = {
							cidade: 'ZZZZ',
							estado: 'ZZZZ',
							grau_lat: dadosTrecho.lat_destino,
							grau_lng: dadosTrecho.lng_destino,
							iata: '',
							id: '',
							id_cidade: '',
							latitude: '',
							local: '',
							longitude: '',
							pais: '',
							sigla: 'ZZZZ',
							uf: null,
							voo_regular: '0'
						}
					} else if(dadosTrecho.nao_tem_aerodromo == '1') {
						designativo_destino = {
							cidade: dadosTrecho.nome_cidade_destino,
							estado: dadosTrecho.nome_estado_destino,
							grau_lat: dadosTrecho.lat_destino,
							grau_lng: dadosTrecho.lng_destino,
							iata: '',
							id: '',
							id_estado_destino: dadosTrecho.id_estado_destino,
							id_cidade: dadosTrecho.id_cidade_partida,
							lat_destino: dadosTrecho.lat_destino,
							lng_destino: dadosTrecho.lng_destino,
							local: '',
							longitude: '',
							pais: '',
							uf: null,
							voo_regular: '0',
							nao_tem_aerodromo: dadosTrecho.nao_tem_aerodromo,
							descricao_destino: dadosTrecho.descricao_destino
						}
					} else{
						designativo_destino =
							trechoPadrao.rotaer_destino.find(
								(designativo) =>
									designativo.sigla == dadosTrecho.designativo_destino
							) ?? {}
					}

					const novosDados = {
						id: dadosTrecho.id,
						numero_voo: dadosTrecho.numero_voo,
						nome_estado_partida: dadosTrecho.nome_estado_partida,
						id_estado_partida: dadosTrecho.id_estado_partida,
						nome_cidade_partida: dadosTrecho.nome_cidade_partida,
						id_cidade_partida: dadosTrecho.id_cidade_partida,
						descricao_partida:
							dadosTrecho.descricao_partida == null
								? ''
								: dadosTrecho.descricao_partida,
						loadCidadePartida: false,
						rotaer_local_partida: dadosTrecho.rotaer_local_partida,
						lat_partida: dadosTrecho.lat_partida,
						lng_partida: dadosTrecho.lng_partida,
						decolagem_partida: this._SQLDateToDateTime(
							dadosTrecho.decolagem_partida,
							window.$sessao.getDateFormat() + ' HH:MM'
						).split(' ')[0],
						decolagem_partida_hora: this._SQLDateToDateTime(
							dadosTrecho.decolagem_partida,
							window.$sessao.getDateFormat() + ' HH:MM'
						).split(' ')[1],
						pouso_previsto: this._SQLDateToDateTime(
							dadosTrecho.pouso_previsto,
							window.$sessao.getDateFormat() + ' HH:MM'
						).split(' ')[0],
						pouso_previsto_hora: dadosTrecho.pouso_previsto
							? this._SQLDateToDateTime(
									dadosTrecho.pouso_previsto,
									window.$sessao.getDateFormat() + ' HH:MM'
							  ).split(' ')[1]
							: '',
						nome_estado_destino: dadosTrecho.nome_estado_destino,
						id_estado_destino: dadosTrecho.id_estado_destino,
						nome_cidade_destino: dadosTrecho.nome_cidade_destino,
						id_cidade_destino: dadosTrecho.id_cidade_destino,
						descricao_destino:
							dadosTrecho.descricao_destino == null
								? ''
								: dadosTrecho.descricao_destino,
						nao_tem_aerodromo:
							dadosTrecho.nao_tem_aerodromo == '0' ? false : true,
						rotaer_local_destino: dadosTrecho.rotaer_local_destino,
						lat_destino: dadosTrecho.lat_destino,
						lng_destino: dadosTrecho.lng_destino,
						adicional: dadosTrecho.adicional,
						pernoite: dadosTrecho.pernoite,
						passageiro: dadosTrecho.passageiro,
						estado_partida,
						cidade_partida,
						designativo_partida,
						estado_destino,
						cidade_destino,
						designativo_destino,
						pais_partida,
						pais_destino,
						trecho: indexTrecho + 1
					}
					return {
						...trechoPadrao,
						...novosDados
					}
				}),window.bus.$emit('load-out')
			)
		}
	}
}
